import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const PacListField = ({ fl, value, onChange, tid, allInputs }) => {
  const pacs = Array.isArray(value) && value.length ? value : [{ puissance: "", perf: "" }];
  const perfLabel = fl.perf_label?.[allInputs?.tranche] || "Performance";
  const set = (i, k, v) => onChange(pacs.map((p, j) => (j === i ? { ...p, [k]: v } : p)));
  const gt = allInputs?.tranche === "gt400";
  const mismatch = (v) => v !== "" && v != null && !Number.isNaN(Number(v)) && (gt ? Number(v) <= 400 : Number(v) > 400);
  const total = pacs.reduce((s, p) => s + (Number(p.puissance) || 0), 0);
  return (
    <div className="space-y-2 sm:col-span-2" data-testid={tid}>
      <div className="flex items-center justify-between">
        <Label className="text-sm">{fl.label} ({pacs.length})</Label>
        <Button type="button" size="sm" variant="outline" className="h-8" onClick={() => onChange([...pacs, { puissance: "", perf: "" }])} data-testid={`${tid}-add`}>
          <Plus className="h-3.5 w-3.5 mr-1" /> Ajouter une PAC
        </Button>
      </div>
      {pacs.map((p, i) => {
        const bad = mismatch(p.puissance);
        return (
        <div key={i} className="space-y-1" data-testid={`${tid}-row-${i}`}>
        <div className="grid grid-cols-[90px_1fr_1fr_36px] gap-2 items-center">
          <span className={`text-xs font-semibold ${bad ? "text-red-600" : "text-muted-foreground"}`}>PAC n°{i + 1}</span>
          <Input type="number" placeholder="Puissance (kW)" value={p.puissance} onChange={(e) => set(i, "puissance", e.target.value)} aria-invalid={bad}
            className={bad ? "border-red-500 text-red-600 focus-visible:ring-red-500 bg-red-50 dark:bg-red-950/40" : ""} data-testid={`${tid}-puissance-${i}`} />
          <Input type="number" placeholder={perfLabel} value={p.perf} onChange={(e) => set(i, "perf", e.target.value)} data-testid={`${tid}-perf-${i}`} />
          <Button type="button" size="icon" variant="ghost" className="h-9 w-9 text-red-600" disabled={pacs.length === 1} onClick={() => onChange(pacs.filter((_, j) => j !== i))} data-testid={`${tid}-remove-${i}`}>
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
        {bad && (
          <p className="text-xs font-medium text-red-600 pl-[98px]" data-testid={`${tid}-error-${i}`}>
            {gt ? "Puissance ≤ 400 kW incompatible avec la tranche « PAC > 400 kW »" : "Puissance > 400 kW incompatible avec la tranche « PAC ≤ 400 kW »"}
          </p>
        )}
        </div>
        );
      })}
      <div className="flex justify-between rounded-lg bg-secondary/60 px-3 py-2 text-sm" data-testid={`${tid}-total`}>
        <span>Puissance totale installée (P)</span>
        <span className="metric font-bold">{total.toLocaleString("fr-FR")} kW</span>
      </div>
      <p className="text-xs text-muted-foreground">Colonnes : puissance (kW) · {perfLabel}. {fl.help}</p>
    </div>
  );
};
